import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import { CancellationReasonPassengerBookingEnum } from '@mopla/data-models';

import { ICancellationReasonFormState } from './types';

/** Matches the BE limit for the free-text reason. */
export const MAX_OTHER_REASON_INPUT = 255;

export const ValidationSchema = yup.object().shape(
	{
		reason: yup.string().when('otherReasonText', {
			is: (v: string) => !v,
			then: (s) => s.required(),
		}),
		otherReasonText: yup
			.string()
			.max(MAX_OTHER_REASON_INPUT)
			.when('reason', {
				is: CancellationReasonPassengerBookingEnum.OTHER_REASON,
				then: (s) => s.required(),
			}),
	},
	[['reason', 'otherReasonText']]
);

export const useCancellationReasonForm = () => {
	return useForm<ICancellationReasonFormState>({
		defaultValues: { reason: '', otherReasonText: '' },
		resolver: yupResolver(ValidationSchema),
		mode: 'onChange',
	});
};
